<app-simple-responsive-frame>
    <div class="details">
        <div class="intro">
            <h2>¿Qué otras características tiene tu {{ segmentLabel?.toLowerCase() }}?</h2>
            <span>Selecciona todas las que apliquen a tu propiedad.</span>
            <small class="selected-hint" *ngIf="selectedCount()">
                {{ selectedCount() }} seleccionada{{ selectedCount() === 1 ? '' : 's' }}
            </small>
        </div>

        <div class="scroll-container">
            <section *ngFor="let group of featureGroups; trackBy: trackByGroup" class="group">
                <h4 class="group-title">{{ group.groupLabel }}</h4>

                <!-- GRID RESPONSIVE -->
                <div class="amenities-grid">
                    <article
                        *ngFor="let feature of group.featureList; trackBy: trackByFeature"
                        class="amenity-card"
                        [class.selected]="isSelected(feature.featureCode)"
                        tabindex="0"
                        role="checkbox"
                        [attr.aria-checked]="isSelected(feature.featureCode)"
                        (click)="toggleFeatureSelection(feature.featureCode)"
                        (keyup.enter)="toggleFeatureSelection(feature.featureCode)"
                        (keyup.space)="toggleFeatureSelection(feature.featureCode)"
                    >
                        <span class="dot" aria-hidden="true"></span>

                        <div class="amenity-content">
                            <div class="title" [title]="feature.featureLabel">
                                {{ feature.featureLabel }}
                            </div>
                            <div class="desc" *ngIf="feature.description">{{ feature.description }}</div>

                            <!-- Campo “Otro” (se muestra si el feature es de texto) -->
                            <input
                                *ngIf="feature.ctInputType === 'TEXT_INPUT' && isSelected(feature.featureCode)"
                                type="text"
                                class="other-input"
                                placeholder="Por favor, especifica"
                                [(ngModel)]="otherValues[feature.featureCode]"
                                (click)="$event.stopPropagation()"
                            />
                        </div>

                        <i class="pi pi-check check-icon" aria-hidden="true"></i>
                    </article>
                </div>
            </section>
        </div>
    </div>

    <!-- Mensaje de error -->
    <div class="error-message" *ngIf="showErrorDialog">
        <ul class="text-danger list-unstyled" style="list-style:none;margin:5px 0 0;padding:0">
            <li><p-message severity="error" [text]="dialogCode + ' ' + dialogMessage"></p-message></li>
        </ul>
    </div>

    <app-page-navigation-bar
        [value]="50"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'details-secondary'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>
